function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg02D(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35.536,
    height: 25.862,
    viewBox: "0 0 35.536 25.862",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "02d"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 184450"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 14410",
    d: "M252.812 65.258a5.226 5.226 0 0 0-5.16-4.042 5.37 5.37 0 0 0-3.286 1.111 9.351 9.351 0 0 0-8.355-5 9.2 9.2 0 0 0-9.235 7.82 6.212 6.212 0 0 0-4.98 5.98 6.274 6.274 0 0 0 6.371 6.133h22.794a6.274 6.274 0 0 0 6.371-6.133 6.19 6.19 0 0 0-4.52-5.869z",
    transform: "translate(-221.797 -51.397)",
    style: {
      fill: "#d32f2f"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 184448"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 14411",
    d: "M246.11 64.765a7.386 7.386 0 0 1 5.983-3.194.443.443 0 0 0 0-.885 8.321 8.321 0 0 0-6.747 3.631c-.328.467.439.91.764.447z",
    transform: "translate(-237.904 -53.704)",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 184449"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 14412",
    d: "M226.451 91.779a4.807 4.807 0 0 1 2.254-4.005c.478-.306.035-1.072-.446-.764a5.722 5.722 0 0 0-2.692 4.769.443.443 0 0 0 .885 0z",
    transform: "translate(-224.384 -71.722)",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 184451"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 14413",
    d: "M286.129 48.349a6.055 6.055 0 0 1 3.045-.807 5.976 5.976 0 0 1 5.75 4.2 7.077 7.077 0 0 1 .728.313 7.947 7.947 0 1 0-13.352-7.248 9.816 9.816 0 0 1 3.829 3.542z",
    transform: "translate(-263.318 -38.43)",
    style: {
      fill: "#ff8826"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg02D);
export default __webpack_public_path__ + "static/media/02D.2d399851e87241bd0997e9441a33c5a4.svg";
export { ForwardRef as ReactComponent };